import { render, staticRenderFns } from "./CommentsBar.vue?vue&type=template&id=2b50cd56"
import script from "./CommentsBar.vue?vue&type=script&lang=js"
export * from "./CommentsBar.vue?vue&type=script&lang=js"
import style0 from "./CommentsBar.vue?vue&type=style&index=0&id=2b50cd56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports